import classes from "./category.module.css";
import CategorySecCards from "./CategorySecCards";
import { memo } from "react";
const CategotySec = () => {
  return (
    <div className="categoryWrap card-wrap">
      <div className="sec-title">
        <h2>Shop by Category</h2>
      </div>
      <div className={classes.categoryRow}>
        <CategorySecCards />
      </div>
    </div>
  );
};
export default memo(CategotySec);
